module.exports = __webpack_public_path__ + "img/gwei.654771d7.svg";